import { jsx as _jsx } from "react/jsx-runtime";
import { Card, CardContent } from "@mui/material";
export var Messages = function () { return (_jsx(Card, { children: _jsx(CardContent, { children: "Messages" }) })); };
